export default __webpack_public_path__ + "static/media/icon-dark-x.97bcea74.svg";